import React, { useState, useEffect } from "react";
import * as S from "./CaixinhaStyle";
import {
  FaSearch,
  FaBoxOpen,
  FaMoneyCheckAlt,
  FaFilter,
  FaPlus,
  FaUsers,
  FaFileContract,
  FaWallet,
  FaPiggyBank,
  FaInfoCircle,
  FaCheckCircle,
} from "react-icons/fa";
import Loading from "../Loader";
import { goldenBoxAdminService } from "../../Services/goldenBoxAdminService";
import { formatDate, formatCurrencyBRL } from "../ASSETS/assets";
import CaixinhaModal from "./CaixinhaModal";
import NovaCaixinha from "./NovaCaixinha/NovaCaixinha";
import { useMessage } from "../../Context/MessageContext";

export default function Caixinha() {
  const [loading, setLoading] = useState(false);
  const { showMessage } = useMessage();

  const [activeTab, setActiveTab] = useState("boxes");

  // --- ESTADOS DA ABA CAIXINHAS ---
  const [boxes, setBoxes] = useState([]);
  const [totalCountBoxes, setTotalCountBoxes] = useState(0);
  const [pageBoxes, setPageBoxes] = useState(1);
  const [clientSearch, setClientSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [optionFilter, setOptionFilter] = useState("");
  const [selectedBox, setSelectedBox] = useState(null);
  const [showNewBoxModal, setShowNewBoxModal] = useState(false);

  // --- ESTADO DAS MÉTRICAS ---
  const [metrics, setMetrics] = useState({
    totalClients: 0,
    totalGoldenBoxes: 0,
    totalActiveGoldenBoxes: 0, // <--- NOVO ESTADO
    totalActiveContractValue: 0,
    totalFinalIncome: 0,
  });

  // --- ESTADOS DA ABA SAQUES ---
  const [withdraws, setWithdraws] = useState([]);
  const [totalCountWithdraws, setTotalCountWithdraws] = useState(0);
  const [pageWithdraws, setPageWithdraws] = useState(1);
  const [withdrawClientSearch, setWithdrawClientSearch] = useState("");
  const [withdrawStatusFilter, setWithdrawStatusFilter] = useState("");

  const limit = 10;

  useEffect(() => {
    if (activeTab === "boxes") fetchBoxes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageBoxes, activeTab]);

  useEffect(() => {
    if (activeTab === "withdraws") fetchWithdraws();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageWithdraws, activeTab]);

  // --- FUNÇÕES CAIXINHAS ---
  const fetchBoxes = async () => {
    try {
      setLoading(true);
      const offset = (pageBoxes - 1) * limit;

      const [listResponse, metricsResponse] = await Promise.all([
        goldenBoxAdminService.searchGoldenBoxes(
          limit,
          offset,
          clientSearch,
          statusFilter,
          optionFilter
        ),
        goldenBoxAdminService.getGeneralMetrics(),
      ]);

      setBoxes(listResponse.data || []);
      setTotalCountBoxes(listResponse.totalCount || 0);

      if (metricsResponse) {
        setMetrics(metricsResponse);
      }
    } catch (error) {
      console.error(error);
      showMessage("Erro ao buscar dados.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSearchBoxes = () => {
    setPageBoxes(1);
    fetchBoxes();
  };

  const handleApproveRejectBox = async (e, id, approved) => {
    e.stopPropagation();
    const action = approved ? "aprovar" : "rejeitar";
    if (!window.confirm(`Tem certeza que deseja ${action} esta caixinha?`))
      return;
    try {
      setLoading(true);
      await goldenBoxAdminService.approveOrReject(id, approved);
      showMessage(
        `Caixinha ${approved ? "aprovada" : "rejeitada"} com sucesso!`,
        "success"
      );
      fetchBoxes();
    } catch (error) {
      showMessage("Erro ao processar solicitação.", "error");
    } finally {
      setLoading(false);
    }
  };

  // --- FUNÇÕES SAQUES ---
  const fetchWithdraws = async () => {
    try {
      setLoading(true);
      const offset = (pageWithdraws - 1) * limit;
      const response = await goldenBoxAdminService.searchWithdraws(
        limit,
        offset,
        withdrawClientSearch,
        withdrawStatusFilter
      );
      setWithdraws(response.data || []);
      setTotalCountWithdraws(response.totalCount || 0);
    } catch (error) {
      console.error(error);
      showMessage("Erro ao buscar saques.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSearchWithdraws = () => {
    setPageWithdraws(1);
    fetchWithdraws();
  };

  const handleApproveRejectWithdraw = async (e, id, approved) => {
    e.stopPropagation();
    const action = approved ? "APROVAR (Pagar)" : "REJEITAR (Estornar)";
    if (!window.confirm(`Tem certeza que deseja ${action} este saque?`)) return;

    try {
      setLoading(true);
      await goldenBoxAdminService.approveOrRejectWithdraw(id, approved);
      showMessage(
        `Saque ${approved ? "aprovado" : "rejeitado"} com sucesso!`,
        "success"
      );
      fetchWithdraws();
    } catch (error) {
      console.error(error);
      showMessage("Erro ao processar saque.", "error");
    } finally {
      setLoading(false);
    }
  };

  // --- HELPERS ---
  const getBoxStatusInfo = (status) => {
    const s = String(status).toUpperCase();
    if (s === "PENDING" || s === "1") return { code: 0, label: "Pendente" };
    if (s === "ACTIVE" || s === "2") return { code: 1, label: "Ativo" };
    if (s === "FINISHED" || s === "3") return { code: 3, label: "Finalizado" };
    if (s === "REJECTED" || s === "4") return { code: 2, label: "Rejeitado" };
    if (s === "CANCELED" || s === "5") return { code: 4, label: "Cancelado" };
    return { code: -1, label: status };
  };

  const getWithdrawStatusInfo = (status) => {
    const s = String(status).toUpperCase();
    if (s === "PENDING" || s === "1") return { code: 0, label: "Pendente" };
    if (s === "PAID" || s === "2") return { code: 1, label: "Pago" };
    if (s === "CANCELED" || s === "3") return { code: 4, label: "Cancelado" };
    if (s === "REJECTED" || s === "4") return { code: 2, label: "Rejeitado" };
    return { code: -1, label: status };
  };

  const totalPagesBoxes = Math.ceil(totalCountBoxes / limit);
  const totalPagesWithdraws = Math.ceil(totalCountWithdraws / limit);

  return (
    <S.Container>
      <Loading load={loading} />

      {/* MODAL DE DETALHES/EDIÇÃO */}
      <CaixinhaModal
        data={selectedBox}
        onClose={() => setSelectedBox(null)}
        onUpdate={fetchBoxes}
      />

      {/* MODAL DE NOVA CAIXINHA */}
      {showNewBoxModal && (
        <NovaCaixinha
          onClose={() => setShowNewBoxModal(false)}
          onUpdate={fetchBoxes}
        />
      )}

      <S.ContentBox>
        <S.Header>
          <h2>
            {activeTab === "boxes" ? <FaBoxOpen /> : <FaMoneyCheckAlt />}
            {activeTab === "boxes"
              ? " Gestão Golden Box - Caixa de ouro"
              : " Gestão de Saques"}
          </h2>
        </S.Header>

        <S.TabContainer>
          <S.TabButton
            active={activeTab === "boxes"}
            onClick={() => setActiveTab("boxes")}
          >
            Gestão Caixinha
          </S.TabButton>
          <S.TabButton
            active={activeTab === "withdraws"}
            onClick={() => setActiveTab("withdraws")}
          >
            Gestão Saques
          </S.TabButton>
        </S.TabContainer>

        {/* ================= ABA CAIXINHAS ================= */}
        {activeTab === "boxes" && (
          <>
            {/* --- CARDS DE MÉTRICAS GERAIS --- */}
            <S.MetricsGrid>
              {/* CARD 1: CLIENTES */}
              <S.MetricCard>
                <div className="icon-box">
                  <FaUsers />
                </div>
                <div className="info">
                  <span className="label">
                    Clientes na Caixinha
                    <S.InfoTooltip data-tooltip="Quantidade dos clientes únicos que aderiram a caixinha">
                      <FaInfoCircle />
                    </S.InfoTooltip>
                  </span>
                  <span className="value">{metrics.totalClients}</span>
                </div>
              </S.MetricCard>

              {/* CARD 2: TOTAL CAIXINHAS */}
              <S.MetricCard>
                <div className="icon-box">
                  <FaFileContract />
                </div>
                <div className="info">
                  <span className="label">
                    TOTAL DE CAIXINHAS
                    <S.InfoTooltip data-tooltip="Quantidade total de contratos vinculados (Total de caixinhas criadas)">
                      <FaInfoCircle />
                    </S.InfoTooltip>
                  </span>
                  <span className="value">{metrics.totalGoldenBoxes}</span>
                </div>
              </S.MetricCard>

              {/* CARD 3: CAIXINHAS ATIVAS (NOVO) */}
              <S.MetricCard>
                <div className="icon-box">
                  <FaCheckCircle />
                </div>
                <div className="info">
                  <span className="label">
                    Caixinhas Ativas
                    <S.InfoTooltip data-tooltip="Quantidade de caixinhas que estão atualmente com status ATIVO">
                      <FaInfoCircle />
                    </S.InfoTooltip>
                  </span>
                  <span className="value">
                    {metrics.totalActiveGoldenBoxes}
                  </span>
                </div>
              </S.MetricCard>

              {/* CARD 4: VALOR CONTRATOS */}
              <S.MetricCard>
                <div className="icon-box">
                  <FaWallet />
                </div>
                <div className="info">
                  <span className="label">
                    Total em Contratos (Ativos)
                    <S.InfoTooltip data-tooltip="Soma do valor (TotalPrice) de todos os contratos vinculados a caixinhas ativas">
                      <FaInfoCircle />
                    </S.InfoTooltip>
                  </span>
                  <span className="value">
                    R$ {formatCurrencyBRL(metrics.totalActiveContractValue)}
                  </span>
                </div>
              </S.MetricCard>

              {/* CARD 5: VALOR FINAL */}
              <S.MetricCard>
                <div className="icon-box">
                  <FaPiggyBank />
                </div>
                <div className="info">
                  <span className="label">
                    Total na Caixinha (Ativos)
                    <S.InfoTooltip data-tooltip="Valor projetado final das caixinhas ativas (Soma da valorização do contrato + bônus mensal)">
                      <FaInfoCircle />
                    </S.InfoTooltip>
                  </span>
                  <span className="value">
                    R$ {formatCurrencyBRL(metrics.totalFinalIncome)}
                  </span>
                </div>
              </S.MetricCard>
            </S.MetricsGrid>

            {/* --- ÁREA DE FILTROS --- */}
            <S.SearchArea>
              <S.FilterGroup>
                <label>Pesquisar Cliente</label>
                <div className="input-wrapper">
                  <input
                    className="search-input"
                    value={clientSearch}
                    onChange={(e) => setClientSearch(e.target.value)}
                    placeholder="Nome ou CPF"
                    onKeyDown={(e) => e.key === "Enter" && handleSearchBoxes()}
                  />
                  <button
                    className="search-icon-btn"
                    onClick={handleSearchBoxes}
                  >
                    <FaSearch />
                  </button>
                </div>
              </S.FilterGroup>
              <S.FilterGroup>
                <label>Status</label>
                <select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="">Todos</option>
                  <option value="1">Pendente</option>
                  <option value="2">Ativo</option>
                  <option value="4">Rejeitado</option>
                  <option value="3">Finalizado</option>
                  <option value="5">Cancelado</option>
                </select>
              </S.FilterGroup>
              <S.FilterGroup>
                <label>Modalidade</label>
                <select
                  value={optionFilter}
                  onChange={(e) => setOptionFilter(e.target.value)}
                >
                  <option value="">Todas</option>
                  <option value="1">Saque Mensal (1.3%)</option>
                  <option value="2">Saque Anual (1.0%)</option>
                </select>
              </S.FilterGroup>

              <div
                style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}
              >
                <S.FilterButton onClick={handleSearchBoxes}>
                  <FaFilter style={{ marginRight: "8px" }} /> Filtrar
                </S.FilterButton>

                {/* BOTÃO DE NOVA CAIXINHA */}
                <S.NewBoxButton onClick={() => setShowNewBoxModal(true)}>
                  <FaPlus /> Nova Caixinha
                </S.NewBoxButton>
              </div>
            </S.SearchArea>

            <S.TableContainer>
              <S.Table>
                <S.TableHead>
                  <tr>
                    <th>ID</th>
                    <th>Data</th>
                    <th>ID Cliente</th>
                    <th>Cliente</th>
                    <th>Modalidade</th>
                    <th>Valor Acumulado</th>
                    <th>Disponível Para Saque Hoje</th>
                    <th>Bônus Atual</th>
                    <th>Bônus Final</th>
                    <th>Status</th>
                    <th>Ações</th>
                  </tr>
                </S.TableHead>
                <S.TableBody>
                  {boxes.length === 0 ? (
                    <tr>
                      <td
                        colSpan="11"
                        style={{
                          textAlign: "center",
                          padding: "30px",
                          color: "#888",
                        }}
                      >
                        Nenhuma caixinha encontrada.
                      </td>
                    </tr>
                  ) : (
                    boxes.map((box) => {
                      const statusInfo = getBoxStatusInfo(box.status);
                      const isPending =
                        String(box.status).toUpperCase() === "PENDING" ||
                        box.status === 1;
                      return (
                        <tr key={box.id} onClick={() => setSelectedBox(box)}>
                          <td>#{box.id}</td>
                          <td>{formatDate(box.dateCreated)}</td>
                          <td>#{box.client?.id}</td>
                          <td>{box.client?.name}</td>
                          <td>
                            {box.goldenBoxOption?.name || box.goldenBoxOptionId}
                          </td>
                          <td>
                            R$
                            {formatCurrencyBRL(
                              box.totalCurrentAccumulated || 0
                            )}
                          </td>
                          <td>
                            R$
                            {formatCurrencyBRL(box.currentAmountAvaliable || 0)}
                          </td>
                          <td>
                            {box.currentBonus
                              ? `${formatCurrencyBRL(box.currentBonus)}%`
                              : "0%"}
                          </td>
                          <td>
                            {box.finalBonus
                              ? `${formatCurrencyBRL(box.finalBonus)}%`
                              : "0%"}
                          </td>
                          <td>
                            <S.StatusBadge status={statusInfo.code}>
                              {statusInfo.label}
                            </S.StatusBadge>
                          </td>
                          <td>
                            {isPending ? (
                              <div onClick={(e) => e.stopPropagation()}>
                                <S.ActionButton
                                  className="approve"
                                  onClick={(e) =>
                                    handleApproveRejectBox(e, box.id, true)
                                  }
                                >
                                  Aceitar
                                </S.ActionButton>
                                <S.ActionButton
                                  className="reject"
                                  onClick={(e) =>
                                    handleApproveRejectBox(e, box.id, false)
                                  }
                                >
                                  Negar
                                </S.ActionButton>
                              </div>
                            ) : (
                              <span style={{ fontSize: "12px", color: "#888" }}>
                                Ver detalhes
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </S.TableBody>
              </S.Table>
            </S.TableContainer>

            <S.PaginationContainer>
              <button
                onClick={() => setPageBoxes((p) => Math.max(1, p - 1))}
                disabled={pageBoxes === 1}
              >
                Anterior
              </button>
              <span>
                Página {pageBoxes} de {totalPagesBoxes || 1}
              </span>
              <button
                onClick={() =>
                  setPageBoxes((p) => Math.min(totalPagesBoxes, p + 1))
                }
                disabled={pageBoxes >= totalPagesBoxes}
              >
                Próxima
              </button>
            </S.PaginationContainer>
          </>
        )}

        {/* ================= ABA SAQUES ================= */}
        {activeTab === "withdraws" && (
          <>
            <S.SearchArea>
              <S.FilterGroup>
                <label>Pesquisar Cliente</label>
                <div className="input-wrapper">
                  <input
                    className="search-input"
                    value={withdrawClientSearch}
                    onChange={(e) => setWithdrawClientSearch(e.target.value)}
                    placeholder="Nome ou CPF"
                    onKeyDown={(e) =>
                      e.key === "Enter" && handleSearchWithdraws()
                    }
                  />
                  <button
                    className="search-icon-btn"
                    onClick={handleSearchWithdraws}
                  >
                    <FaSearch />
                  </button>
                </div>
              </S.FilterGroup>
              <S.FilterGroup>
                <label>Status Saque</label>
                <select
                  value={withdrawStatusFilter}
                  onChange={(e) => setWithdrawStatusFilter(e.target.value)}
                >
                  <option value="">Todos</option>
                  <option value="1">Pendente</option>
                  <option value="2">Pago</option>
                  <option value="4">Rejeitado</option>
                  <option value="3">Cancelado</option>
                </select>
              </S.FilterGroup>
              <div />
              <div style={{ display: "flex", alignItems: "flex-end" }}>
                <S.FilterButton onClick={handleSearchWithdraws}>
                  <FaFilter style={{ marginRight: "8px" }} /> Filtrar
                </S.FilterButton>
              </div>
            </S.SearchArea>

            <S.TableContainer>
              <S.Table>
                <S.TableHead>
                  <tr>
                    <th>ID Saque</th>
                    <th>Data</th>
                    <th>Cliente</th>
                    <th>CPF</th>
                    {/* --- DADOS BANCÁRIOS --- */}
                    <th>Banco</th>
                    <th>Agência</th>
                    <th>Conta</th>
                    <th>Tipo</th>
                    <th>Chave Pix</th>
                    {/* ----------------------- */}
                    <th>Caixinha ID</th>
                    <th>Valor Solicitado</th>
                    <th>Status</th>
                    <th>Ações</th>
                  </tr>
                </S.TableHead>
                <S.TableBody>
                  {withdraws.length === 0 ? (
                    <tr>
                      <td
                        colSpan="13"
                        style={{
                          textAlign: "center",
                          padding: "30px",
                          color: "#888",
                        }}
                      >
                        Nenhum saque encontrado.
                      </td>
                    </tr>
                  ) : (
                    withdraws.map((w) => {
                      const statusInfo = getWithdrawStatusInfo(w.status);
                      const isPending =
                        String(w.status).toUpperCase() === "PENDING" ||
                        w.status === 1;

                      const bankAccount = w.client?.bankAccount || {};

                      return (
                        <tr key={w.id}>
                          <td>#{w.id}</td>
                          <td>{formatDate(w.dateCreated)}</td>
                          <td>{w.client?.name}</td>
                          <td>{w.client?.cpfCnpj}</td>

                          {/* --- DADOS BANCÁRIOS --- */}
                          <td>{bankAccount.bank || "-"}</td>
                          <td>{bankAccount.agencyNumber || "-"}</td>
                          <td>{bankAccount.accountNumber || "-"}</td>
                          <td>{bankAccount.accountType || "-"}</td>
                          <td style={{ color: "#E6AA3A" }}>
                            {bankAccount.pixKey || "-"}
                          </td>
                          {/* ----------------------- */}

                          <td>#{w.goldenBoxId}</td>
                          <td style={{ color: "#E6AA3A", fontWeight: "bold" }}>
                            {formatCurrencyBRL(w.amountWithdrawn)}
                          </td>
                          <td>
                            <S.StatusBadge status={statusInfo.code}>
                              {statusInfo.label}
                            </S.StatusBadge>
                          </td>
                          <td>
                            {isPending ? (
                              <div>
                                <S.ActionButton
                                  className="approve"
                                  onClick={(e) =>
                                    handleApproveRejectWithdraw(e, w.id, true)
                                  }
                                >
                                  Pagar
                                </S.ActionButton>
                                <S.ActionButton
                                  className="reject"
                                  onClick={(e) =>
                                    handleApproveRejectWithdraw(e, w.id, false)
                                  }
                                >
                                  Rejeitar
                                </S.ActionButton>
                              </div>
                            ) : (
                              <span style={{ fontSize: "12px", color: "#888" }}>
                                {statusInfo.label}
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </S.TableBody>
              </S.Table>
            </S.TableContainer>

            <S.PaginationContainer>
              <button
                onClick={() => setPageWithdraws((p) => Math.max(1, p - 1))}
                disabled={pageWithdraws === 1}
              >
                Anterior
              </button>
              <span>
                Página {pageWithdraws} de {totalPagesWithdraws || 1}
              </span>
              <button
                onClick={() =>
                  setPageWithdraws((p) => Math.min(totalPagesWithdraws, p + 1))
                }
                disabled={pageWithdraws >= totalPagesWithdraws}
              >
                Próxima
              </button>
            </S.PaginationContainer>
          </>
        )}
      </S.ContentBox>
    </S.Container>
  );
}
